module.exports = __webpack_public_path__ + "img/88_2.e108ca10.png";